export default function ClearSky() {
  return (
    <div className="atmos-animation atmos-clear-sky" aria-hidden="true">
      <span className="atmos-sun-ray" />
      <span className="atmos-sun-ray atmos-sun-ray-soft" />
    </div>
  );
}
